import {ConflictHandlerInstance} from '../../interfaces/core/conflict-handler-instance';
import {SyncStatusItem} from '../../interfaces/core/sync-status-item';
import {SyncException} from '../../exceptions/sync.exception';
import {AlertController, LoadingController} from '@ionic/angular';
import {inject, Injectable} from '@angular/core';
import {TtActivityEntriesTable} from '../time-tracking/tt-activity-entries.table';
import {Router} from '@angular/router';
import {TtActivityEntriesService} from '../../services/time-tracking/tt-activity-entries.service';

@Injectable({
  providedIn: 'root'
})
export class TtActivityEntryConflictHandler implements ConflictHandlerInstance {

  private _router: Router;
  private _loadingController: LoadingController;
  private _alertController: AlertController;
  private _ttActivityEntriesTable: TtActivityEntriesTable;
  private _ttActivityEntriesService: TtActivityEntriesService;

  constructor() {
    this._router = inject(Router);
    this._loadingController = inject(LoadingController);
    this._ttActivityEntriesTable = inject(TtActivityEntriesTable);
    this._ttActivityEntriesService = inject(TtActivityEntriesService);
    this._alertController = inject(AlertController);
  }

  /**
   *
   * @param syncStatusItem
   * @param syncException
   */
  public async handleConflict(syncStatusItem: SyncStatusItem, syncException: SyncException): Promise<void> {
    if(syncException.code !== 409) {
      return;
    }

    const loader = await this._loadingController.create({
      message: 'Konflikt erkannt...'
    });
    await loader.present();

    const ttActivityEntry = await this._ttActivityEntriesTable.get(syncStatusItem.primaryKey);
    await this._ttActivityEntriesService.deleteTtActivityEntry(syncStatusItem.primaryKey, true);
    await loader.dismiss();

    const name = ttActivityEntry.ttActivityType.name;

    const alert = await this._alertController.create({
      header: 'Konflikt',
      message: 'Es gab einen Konflikt mit einem Zeitbuchungseintrag. Der Eintrag wurde gelöscht. Bitte überprüfen Sie Ihre Zeitbuchungen. \n' + name,
      buttons: ['OK']
    });

    await alert.present();

    if(await this.checkActiveRoute()) {
      await this._router.navigate(['tabs', 'employee']);
    }
  }

  /**
   *
   * @private
   */
  private async checkActiveRoute(): Promise<boolean> {
    const cdRaiRoute = this._router.createUrlTree(['tabs', 'time-tracking']);
    const cdRaiEditRoute = this._router.createUrlTree(
      ['tabs', 'time-tracking']
    );
    // TODO: Deprecated isActive method
    return this._router.isActive(cdRaiRoute, true) || this._router.isActive(cdRaiEditRoute, true);
  }
}
